import axios from "axios";
import api_response from "./api-response";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60 * 1000,
  headers: {
    Authorization: `Bearer ${localStorage.getItem(
      process.env.VUE_APP_STORAGE_KEY + "_token"
    )}`,
  },
});

instance.interceptors.request.use(
  function (config) {
    let data = config.data;

    if (data) {
      if (data instanceof FormData) {
        if (data.get("form_id")) {
          api_response.load(data.get("form_id"));
        }
      } else {
        if (data.form_id) {
          api_response.load(data.form_id);
        }
      }
    }

    return config;
  },
  function (error) {
    api_response.stopLoading();
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    api_response.stopLoading();
    return response;
  },
  function (error) {
    if (error.response) {
      api_response.handle(error.response);
    } else {
      api_response.stopLoading(
        "There was an error processing your request. Please try again later."
      );
    }

    return Promise.reject(error);
  }
);

export default instance;
